<template>
  <require from="framework/html_behaviors/af-autogrow"></require>
  <require from="framework/value_converters/empty-as-null"></require>

  <div class="form-group bs-form-textarea">
    <textarea class="form-control ${controlClass} ${value ? '' : 'af-valuable--emptyvalue'}" placeholder.bind="placeholder" value.bind="value | emptyAsNull" rows.bind="rows" disabled.bind="disabled" maxlength.bind="maxlength" af-autogrow.bind="autogrow" focus.bind="hasfocus" blur.trigger="blur()"></textarea>
    <small class="form-label" repeat.for="label of labels">${label}</small>
  </div>
</template>
